import cx from 'classnames';
import { STROLLER_UNPREPARED_TAG } from 'mk/autogenerated/translations/StrollersItem.f9f912134fc171a08f63670dfc4d5d27'
import { ScoreNumber, ScoreNumberType } from 'mk2/apps/strollers/components/ScoreNumber';
import { WishlistToggle } from 'mk2/apps/strollers/components/WishlistToggle';
import { StrollerEntity } from 'mk2/apps/strollers/schemas';
import { strollersDetailUrl } from 'mk2/apps/strollers/urls';
import Img from 'mk2/components/Img';
import ImgCropped, { ImgCropMode } from 'mk2/components/ImgCropped';
import Link from 'mk2/components/Link';
import LoadingPlaceholder from 'mk2/components/LoadingPlaceholder';
import { url } from 'mk2/helpers/urls';
import React from 'react';
import styles from './StrollersItem.mscss';

interface OwnProps {
    stroller: StrollerEntity;
    style?: object;
    smallText?: boolean;

    isInWishList: boolean;
    onWishlistToggleClick(strollerId);
}

export class StrollersItem extends React.Component<OwnProps> {

    public render() {
        const { isInWishList, onWishlistToggleClick, smallText, stroller, style } = this.props;

        const strollerPhoto = stroller.firstPhoto;

        return (
            <div style={style}>
                <div className={styles.StrollersItem}>
                    <Link
                        className={styles.StrollersItem__item}
                        to={url(strollersDetailUrl, { slug: stroller.slug })}
                    >
                        <span className={styles['StrollersItem__item--image']}>
                            {(strollerPhoto) && (
                                <ImgCropped
                                    width={100}
                                    height={100}
                                    mode={ImgCropMode.Embed}
                                    imgWidth={strollerPhoto.originalWidth}
                                    imgHeight={strollerPhoto.originalHeight}
                                    imgUrl={strollerPhoto.url100x100}
                                    lazy={false}
                                />
                            )}
                        </span>
                        <span className={styles.StrollersItem__data}>
                            <h2 className={cx(styles.StrollersItem__name, {[styles['StrollersItem__name--smallText']]: smallText})}>
                                {stroller.name}
                            </h2>
                            {!stroller.prepared && (
                                <div className={styles.StrollersItem__unprepared}>
                                    <span className={styles.StrollersItem__unpreparedTag}>
                                        {STROLLER_UNPREPARED_TAG}
                                    </span>
                                </div>
                            )}
                            <span className={styles.StrollersItem__rating}>
                                {stroller.userScore && (
                                    <ScoreNumber score={parseFloat(stroller.userScore.toFixed(1))} type={ScoreNumberType.Small} />
                                )}
                                {/*
                                <i className={styles['StrollersItem__rating--review']}>7</i>
                                */}
                            </span>
                        </span>
                        <i className={cx('fa', 'fa-angle-right', styles.StrollersItem__arrowIcon)} />
                    </Link>
                    <WishlistToggle active={isInWishList} onClick={onWishlistToggleClick} />
                </div>
            </div>
        );
    }
}

interface PlaceholderOwnProps {
    style?: object;
    smallText?: boolean;
}

export const StrollersItemPlaceholder: React.StatelessComponent<PlaceholderOwnProps> = ({ style, smallText }) => (
    <div style={style}>
        <div className={styles.StrollersItem}>
            <span className={styles.StrollersItem__item}>
                <span className={styles['StrollersItem__item--image']}>
                    <Img
                        width={100}
                        height={99}
                        alt="Loading..."
                        src="https://mkimgstrollerssk.vshcdn.net/spsp/100x100/OZ4GHQYqGs7.png"
                    />
                </span>
                <span className={styles.StrollersItem__data}>
                    <h2 className={cx(styles.StrollersItem__name, {[styles['StrollersItem__name--smallText']]: smallText})}>
                        <LoadingPlaceholder width={150} height={21} />
                    </h2>
                </span>
            </span>
        </div>
    </div>
);
StrollersItemPlaceholder.displayName = 'StrollersItemPlaceholder';
